/** Selectable first day of week values (merchant analytics / settings). */
export const DAY_OF_WEEK_VALUES = ['saturday', 'sunday', 'monday', 'tuesday'] as const;

/** Used when merchant has no `analytics.first_day_of_week` in settings. */
export const DEFAULT_FIRST_DAY_OF_WEEK = 'sunday' satisfies (typeof DAY_OF_WEEK_VALUES)[number];

/** TikTok Shop sample cost setting: decimal precision (see `useMerchantSampleCost`). */
export const MERCHANT_SAMPLE_COST_MAX_DECIMAL_DIGITS = 2;

/** Default invitation message field (see `useMerchantDefaultInvitationMessage`). */
export const MERCHANT_DEFAULT_INVITATION_MESSAGE_MAX_LENGTH = 500;

/** Shown and used as the baseline when the API has no saved message yet. */
export const MERCHANT_DEFAULT_INVITATION_MESSAGE_FALLBACK =
  "Hi there! We would like to extend you an invitation to collaborate with us. Check out our incredible products and exclusive invitation commission and let's get something going!";

/** Maximum allowed sample cost (inclusive). */
export const MERCHANT_SAMPLE_COST_MAX = 9_999.99;

/** Creator tier range bounds (GMV in currency, followers as a count). */
export const GMV_MIN = 0;
export const GMV_MAX = 1_500_000;
export const FOLLOWERS_MIN = 0;
export const FOLLOWERS_MAX = 10_000_000;

/** Maximum number of real (non-filler) tiers a merchant can define. */
export const MAX_TIERS = 7;
